module.exports = __webpack_public_path__ + "img/shopping-basket-fill.db5e4caa.svg";